export const GOOGLE_MAPS_MAP_ID =
  process.env.NEXT_PUBLIC_GN_GOOGLE_MAPS_MAP_ID ?? '';

export const buildMarkerClustererElement = (count: number) => {
  const container = document.createElement('div');
  container.style.position = 'relative';
  container.style.display = 'flex';
  container.style.alignItems = 'center';
  container.style.justifyContent = 'center';

  const icon = document.createElement('img');
  icon.src = '/icons/Map-Icon_Spark.svg';
  icon.alt = 'Event cluster marker';
  icon.style.width = '56px';
  icon.style.height = '56px';

  const label = document.createElement('span');
  label.textContent = String(count);
  label.style.position = 'absolute';
  label.style.color = 'white';
  label.style.fontWeight = 'bold';
  label.style.fontSize = '14px';
  label.style.textShadow = '0 1px 2px rgba(0,0,0,0.5)';

  container.appendChild(icon);
  container.appendChild(label);

  return container;
};
